import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";

export class RelatedEntitiesRequestParams extends BaseApiRequestParams {
  competitions: Array<Number>;
  competitors: Array<Number>;
  athletes: Array<Number>;

  constructor(competitions: Array<Number>, competitors: Array<Number>, athletes: Array<Number>) {
    super('relatedEntities/');

    this.competitions = competitions;
    this.competitors = competitors;
    this.athletes = athletes;
  }

  get competitionsParam() {
    return this.competitions?.length > 0 ? `&competitions=${this.competitions.toString()}` : '';
  }

  get competitorsParam() {
    return this.competitors?.length > 0 ? `&competitors=${this.competitors.toString()}` : '';
  }

  get athletesParam() {
    return this.athletes?.length > 0 ? `&athletes=${this.athletes.toString()}` : '';
  }

  toString(): string {
    return super.toString() + this.competitionsParam + this.competitorsParam + this.athletesParam;
  }

  equals(model: RelatedEntitiesRequestParams): Boolean {
    let equals = super.equals(model);

    equals &= this.competitionsParam === model.competitionsParam;
    equals &= this.competitorsParam === model.competitorsParam;
    equals &= this.athletesParam === model.athletesParam;

    return equals;
  }
}
